'use strict';

var React = require('react'),
    Link = require('./Link'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

var DraftLink = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    draft: PropTypes.object.isRequired,
    emptyTitle: PropTypes.string,
    bold: PropTypes.bool
  },

  render() {
    const { draft, children, bold, showTitle, emptyTitle } = this.props;

    return (
      <Link to='draftPreview'
            params={{ stampSegment: draft.uuid }}
            bold={bold}
            title={showTitle && draft.title}>
        {children || draft.title || emptyTitle}
      </Link>
    );
  }
});

module.exports = DraftLink;


/** WEBPACK FOOTER **
 ** ./atoms/DraftLink.jsx
 **/